import { IonButton, IonIcon } from '@ionic/react';
import { timeOutline } from 'ionicons/icons';
import React, { useEffect, useRef, useState } from 'react';

interface Props {
    onContinue: () => void;
    onReset: () => void;
}

const COUNTDOWN_SECONDS = 10;

const InactivityOverlay: React.FC<Props> = ({ onContinue, onReset }) => {
    const [countdown, setCountdown] = useState(COUNTDOWN_SECONDS);
    const onResetRef = useRef(onReset);

    // Mantém o ref sempre atualizado sem re-disparar o effect
    useEffect(() => {
        onResetRef.current = onReset;
    }, [onReset]);

    useEffect(() => {
        const timer = setInterval(() => {
            setCountdown(prev => {
                if (prev <= 1) {
                    clearInterval(timer);
                    onResetRef.current(); // usa o ref, não a prop diretamente
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
        return () => clearInterval(timer);
    }, []); // ← sem dependências: roda uma única vez ao montar

    return (
        <div className="totem-inactivity-overlay">
            <div className="totem-inactivity-card">
                <h2 className="totem-inactivity-title">Atenção!</h2>
                <hr className="totem-inactivity-divider" />
                <p className="totem-inactivity-msg">
                    Seu pedido será cancelado em <strong>{countdown} segundos</strong> por inatividade.
                </p>
                <IonIcon icon={timeOutline} className="totem-inactivity-clock" />
                <p className="totem-inactivity-question">Deseja continuar com o pedido?</p>
                <div className="totem-inactivity-actions">
                    <IonButton fill="outline" color="danger" size="large" onClick={onReset}>
                        Cancelar pedido
                    </IonButton>
                    <IonButton color="success" size="large" onClick={onContinue}>
                        Continuar pedido
                    </IonButton>
                </div>
            </div>
        </div>
    );
};

export default InactivityOverlay;
